// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SuggestionFooter_wrapper__jLi7R","title":"SuggestionFooter_title__28xNz","buttonSection":"SuggestionFooter_buttonSection__5izdO"};